import { BREAKPOINTS } from "shared/styles/base";

export const serverResponsiveMode = (userAgent = ""): number =>
    userAgent.match(/mobile|phone/i) ? BREAKPOINTS.MOBILE : BREAKPOINTS.DESKTOP + 1;

export const browserResponsiveMode = () => window.innerWidth;

export const canShow = (breakpoint: number, deviceWidth: number, up: boolean, down: boolean) => {
    if (up && deviceWidth > breakpoint) {
        return true;
    }

    if (down && deviceWidth <= breakpoint) {
        return true;
    }

    if (breakpoint === deviceWidth) {
        return true;
    }

    return false;
};
